import React, { useState, useEffect } from 'react';

const SlideEffect = ({ disableSlide, children, className }) => {
    const [start, setStart] = useState(disableSlide);
    const [finished, setFinished] = useState(false);

    useEffect(() => {
        // Timer 1: start animation
        const startTimer = setTimeout(() => {
            setStart(true);
        }, 10);

        // Timer 2: mark finished
        const finishTimer = setTimeout(() => {
            setFinished(true);
        }, 1000);

        // Cleanup to prevent state update on unmounted component
        return () => {
            clearTimeout(startTimer);
            clearTimeout(finishTimer);
        };
    }, [disableSlide]);

    return (
        <div
            className={
                className +
                " " +
                (start ? "opacity-100 mt-0" : "opacity-0 -mt-12") +
                (!finished ? " transform transition-all duration-500 ease-out" : "")
            }
        >
            {children}
        </div>
    );
};

export default SlideEffect;
